import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useState, useEffect, useCallback, useRef } from "react";
import Paginations from "../GenericComponents/Pagination";
import { Link } from "react-router-dom";
import moment from "moment";
import DOMPurify from "dompurify";
import { search_ApiManager, view_ApiManager } from "../ApiManager/ApiManager";
import "./finance.css";
import ExportOptions from "../GenericComponents/ExportOptions";
import { Sorting } from "../GenericComponents/SortTables";
import Title from "../GenericComponents/Title";
import { commissionSortBy, paymentStatus } from "../../utilis/appStatus";
import MultipleSearchs from "../GenericComponents/MultipleSearchs";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import AppsCommission from "../GenericComponents/AppsCommission";

const ViewCommissions = () => {
  // Ref for scroll
  const scrollRef = useRef(null);

  // Initialize state from localStorage
  const permissions = getPermissions() || {};
  const userDetail = JSON.parse(localStorage.getItem("user")) || {};
  const [selectedCommission, setSelectedCommission] = useState({});
  const [data, setData] = useState([]);
  const [details, setDetails] = useState({});
  // State
  const [state, setState] = useState({
    client: "",
    course: "",
    status: "",
    sortType: "",
    loading: false,
    currentPage: 1,
    totalItem: "",
    lastPage: "",
    perPage: 25,
    search: "",
    order: "ASC",
    perItem: "",
    allPermissions: permissions,
    selectedCommissions: [],
    allCommissions: [],
    showHistory: false,
    selectedId: "",
    userRole: userDetail,
    provider: "",
    openModal: false,
    histroyHeaders: [
      { name: "PaymentDate", align: "text-center", field: "name", key: 2 },
      { name: "Amount", field: "amount", align: "text-center", key: 3 },
    ],
    headers: [
      {
        title: "#",
        dataKey: "index",
        align: "text-center",
        key: 1,
        checked: true,
        canChange: false,
      },
      {
        title: "Name",
        dataKey: "name",
        align: "text-center",
        key: 2,
        checked: true,
        canChange: true,
      },
      {
        title: "Installment#",
        dataKey: "installment",
        align: "text-center",
        key: 3,
        checked: true,
        canChange: true,
      },
      {
        title: "Course",
        dataKey: "coursename",
        align: "text-center",
        key: 4,
        checked: true,
        canChange: true,
      },
      {
        title: "Amount",
        dataKey: "amount",
        align: "text-center",
        key: 5,
        checked: true,
        canChange: true,
      },
      {
        title: "Com%",
        dataKey: "commission",
        align: "text-center",
        key: 6,
        checked: true,
        canChange: true,
      },
      {
        title: "Incl_Com",
        dataKey: "commissionincl",
        align: "text-center",
        key: 7,
        checked: false,
        canChange: true,
      },
      {
        title: "Excl_Com",
        dataKey: "commissionexcl",
        align: "text-center",
        key: 8,
        checked: false,
        canChange: true,
      },
      {
        title: "Due_Date",
        dataKey: "duedate",
        align: "text-center",
        key: 9,
        checked: true,
        canChange: true,
      },
      {
        title: "Payment_Date",
        dataKey: "paymentdate",
        align: "text-left",
        key: 10,
        checked: true,
        canChange: true,
      },
      {
        title: "Remaining",
        dataKey: "remaining_amount",
        align: "text-left",
        key: 11,
        checked: true,
        canChange: true,
      },
      {
        title: "Status",
        dataKey: "status",
        align: "text-center",
        key: 12,
        checked: true,
        canChange: true,
      },
      {
        title: "Discount",
        dataKey: "discount",
        align: "text-center",
        key: 13,
        checked: true,
        canChange: true,
      },
      {
        title: "Dis_Incl_Gst",
        dataKey: "discount_incl_gst",
        align: "text-center",
        key: 14,
        checked: false,
        canChange: true,
      },
      {
        title: "Dis_Excl_Gst",
        dataKey: "discount_excl_gst",
        align: "text-center",
        key: 15,
        checked: false,
        canChange: true,
      },
      {
        title: "Bonus",
        dataKey: "app_bonus",
        align: "text-center",
        key: 16,
        checked: false,
        canChange: true,
      },
      {
        title: "Comments",
        dataKey: "notes",
        align: "text-center",
        key: 17,
        checked: true,
        canChange: true,
      },
      {
        title: "Provider",
        dataKey: "pname",
        align: "text-center",
        key: 18,
        checked: true,
        canChange: true,
      },
      {
        title: "Actions",
        dataKey: "action",
        align: "text-center",
        key: 19,
        checked: true,
        canChange: false,
      },
    ],
    overdue_headers: [
      {
        title: "#",
        dataKey: "index",
        align: "text-center",
        key: 1,
        checked: true,
        canChange: false,
      },
      {
        title: "Name",
        dataKey: "name",
        align: "text-center",
        key: 2,
        checked: true,
        canChange: true,
      },
      {
        title: "Installment#",
        dataKey: "installment",
        align: "text-center",
        key: 3,
        checked: true,
        canChange: true,
      },
      {
        title: "Course",
        dataKey: "coursename",
        align: "text-center",
        key: 4,
        checked: true,
        canChange: true,
      },
      {
        title: "Amount",
        dataKey: "amount",
        align: "text-center",
        key: 5,
        checked: true,
        canChange: true,
      },
      {
        title: "Com%",
        dataKey: "commission",
        align: "text-center",
        key: 6,
        checked: true,
        canChange: true,
      },
      {
        title: "Incl_Com",
        dataKey: "commissionincl",
        align: "text-center",
        key: 7,
        checked: false,
        canChange: true,
      },
      {
        title: "Excl_Com",
        dataKey: "commissionexcl",
        align: "text-center",
        key: 8,
        checked: false,
        canChange: true,
      },
      {
        title: "Due_Date",
        dataKey: "duedate",
        align: "text-center",
        key: 9,
        checked: true,
        canChange: true,
      },
      {
        title: "DueBy",
        dataKey: "dueby",
        align: "text-center",
        key: 10,
        checked: true,
        canChange: true,
      },
      {
        title: "Remaining",
        dataKey: "remaining_amount",
        align: "text-left",
        key: 11,
        checked: true,
        canChange: true,
      },
      {
        title: "Status",
        dataKey: "status",
        align: "text-center",
        key: 12,
        checked: true,
        canChange: true,
      },
      {
        title: "Discount",
        dataKey: "discount",
        align: "text-center",
        key: 13,
        checked: true,
        canChange: true,
      },
      {
        title: "Dis_Incl_Gst",
        dataKey: "discount_incl_gst",
        align: "text-center",
        key: 14,
        checked: false,
        canChange: true,
      },
      {
        title: "Dis_Excl_Gst",
        dataKey: "discount_excl_gst",
        align: "text-center",
        key: 15,
        checked: false,
        canChange: true,
      },
      {
        title: "Bonus",
        dataKey: "app_bonus",
        align: "text-center",
        key: 16,
        checked: true,
        canChange: true,
      },
      {
        title: "Comments",
        dataKey: "notes",
        align: "text-center",
        key: 17,
        checked: true,
        canChange: true,
      },
      {
        title: "Provider",
        dataKey: "pname",
        align: "text-center",
        key: 18,
        checked: true,
        canChange: true,
      },
      {
        title: "Actions",
        dataKey: "action",
        align: "text-center",
        key: 19,
        checked: true,
        canChange: false,
      },
    ],
  });
  // Get commissions
  const getCommissions = useCallback(() => {
    setState((prev) => ({ ...prev, loading: true }));
    const { currentPage, perPage } = state;

    console.log(perPage);
    const url = `getAllCommissions`;
    console.log(url);

    view_ApiManager(
      url,
      currentPage,
      perPage,
      (res) => {
        console.log("All-Commissions", res);
        const data = res.data.data;
        const options = data.data.map((item) => ({
          index: item.index,
          name: item.clientname,
          coursename: item.coursename,
          installment_no: item.installment_no,
          amount: item.amount,
          commission: item.commission,
          commissionincl: item.commissionincl,
          commissionexl: item.commissionexcl, // Note: typo in original (exl vs excl)
          duedate: item.duedate,
          dueby: item.dueby,
          paiddate: item.paiddate,
          remaining_amount: item.remaining_amount,
          status: item.status,
          discount: item.discount,
          discount_incl_gst: item.discount_incl_gst,
          discount_excl_gst: item.discount_excl_gst,
          app_bonus: item.app_bonus,
          created_at: moment(item.created_at).format("YYYY-MM-D"),
        }));

        setState((prev) => ({
          ...prev,
          allCommissions: data.data,
          loading: false,
          totalItem: data.total,
          perPage: data.per_page,
          lastPage: data.last_page,
          perItem: data.data.length,
          selectedCommissions: options,
        }));
      },
      (err) => {
        console.log(err);
        setState((prev) => ({ ...prev, loading: false }));
      }
    );
  }, [state.currentPage, state.perPage]);

  // On mount
  useEffect(() => {
    window.scrollTo(0, 0);
    getCommissions();
  }, [getCommissions]);

  // Pagination handler
  const handlePaginationCallback = useCallback(
    (i, perPage) => {
      const scrollToTop = () => {
        if (scrollRef.current) {
          window.scrollTo(0, scrollRef.current.offsetTop);
        } else {
          window.scrollTo(0, 0);
        }
      };

      scrollToTop();

      if (state.search === "") {
        if (perPage && perPage !== "") {
          setState(
            (prev) => ({ ...prev, perPage, currentPage: 1 }),
            () => {
              getCommissions();
            }
          );
        } else {
          setState(
            (prev) => ({ ...prev, currentPage: i }),
            () => {
              getCommissions();
            }
          );
        }
      } else {
        if (perPage && perPage !== "") {
          setState(
            (prev) => ({ ...prev, perPage, currentPage: 1 }),
            () => {
              handleSearchCallback("yes");
            }
          );
        } else {
          setState(
            (prev) => ({ ...prev, currentPage: i }),
            () => {
              handleSearchCallback("yes");
            }
          );
        }
      }
    },
    [state.search, getCommissions]
  );

  const handleCommissiontModelCallback = (type) => {
    if (type === "cancel") {
      setState((prev) => ({
        ...prev,
        openModal: false,
      }));
    }
    if (type === "getInstallments") {
      getCommissions();
      userCommissionDetails();
    }
  };

  // Search handler
  const handleSearchCallback = useCallback(
    (input1, input2, input3, input4, input5) => {
      let Client, Course, Status, Sort, Provider;

      if (input1 === "yes") {
        Client = state.client;
        Course = state.course;
        Status = state.status;
        Sort = state.sortType;
        Provider = state.provider;
      } else {
        Client = input1;
        Course = input2;
        Status = input3;
        Sort = input4;
        Provider = input5;
        setState((prev) => ({
          ...prev,
          search: "yes",
          client: Client,
          course: Course,
          status: Status,
          sortType: Sort,
          provider: Provider,
        }));
      }

      const { currentPage, perPage } = state;
      const url = `search/commissions`;
      const data = {
        client: Client,
        course: Course,
        status: Status,
        sort: Sort,
        provider: Provider,
      };
      console.log(data);

      search_ApiManager(
        url,
        data,
        currentPage,
        perPage,
        (res) => {
          console.log("search-result", res);
          const dataRes = res.data.data;
          const options = dataRes.data.map((item) => ({
            name: item.clientname,
            coursename: item.coursename,
            installment_no: item.installment_no,
            amount: item.amount,
            commission: item.commission,
            commissionincl: item.commissionincl,
            commissionexl: item.commissionexcl, // typo preserved
            duedate: item.duedate,
            dueby: item.dueby,
            paiddate: item.paiddate,
            remaining_amount: item.remaining_amount,
            status: item.status,
            discount: item.discount,
            discount_incl_gst: item.discount_incl_gst,
            discount_excl_gst: item.discount_excl_gst,
            app_bonus: item.app_bonus,
            provider: item.pname,
            created_at: moment(item.created_at).format("YYYY-MM-D"),
          }));

          setState((prev) => ({
            ...prev,
            allCommissions: dataRes.data,
            loading: false,
            totalItem: dataRes.total,
            perPage: dataRes.per_page,
            lastPage: dataRes.last_page,
            perItem: dataRes.data.length,
            selectedCommissions: options,
          }));
        },
        (err) => {
          console.log(err);
        }
      );
    },
    [state]
  );

  // Sorting
  const sorting = useCallback(
    (col) => {
      const sortResult = Sorting(state.allCommissions, col, state.order);
      setState((prev) => ({
        ...prev,
        order: sortResult[0],
        allCommissions: sortResult[1],
      }));
    },
    [state.allCommissions, state.order]
  );

  // Column toggle
  const handleColumnsCallback = useCallback((selectedColumns) => {
    setState((prev) => ({
      ...prev,
      ...(prev.sortType === "overdue"
        ? { overdue_headers: selectedColumns }
        : { headers: selectedColumns }),
    }));
  }, []);

  // Determine headers based on sortType
  const headers =
    state.sortType === "overdue" ? state.overdue_headers : state.headers;

  // Role for export
  const role = JSON.parse(localStorage.getItem("user_role")) || null;

  // get commisions detail about a user
  const userCommissionDetails = async () => {
    try {
      const result = await apiUrl.get(
        `/eduAppCourses/${selectedCommission?.appid}/${selectedCommission?.type}`
      );
      if (result?.status) {
        setData(result?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const clientDetail = async () => {
    try {
      const response = await apiUrl.get(
        `/clientDetails/${selectedCommission?.clientid}`
      );
      if (response?.data?.status) {
        setDetails(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    userCommissionDetails();
    clientDetail();
  }, [selectedCommission]);
  return (
    <>
      <Title title="View Commissions" />
      <div className="row w-100 pl-3 pr-3 mb-5" ref={scrollRef}>
        <MultipleSearchs
          input1={"Search Client"}
          input1_type={"input"}
          input2={"Search Course"}
          input2_type={"input"}
          input3={"Search Status"}
          input3_type={"dropdown"}
          input3_multiple={"no"}
          input3Data={paymentStatus}
          input4={"Search SortBy"}
          input4_type={"dropdown"}
          input4_multiple={"no"}
          input4Data={commissionSortBy}
          input4_filter_by={"label"}
          input5={"Search Provider"}
          input5_type={"input"}
          onSearchChange={handleSearchCallback}
          onColumnsChange={handleColumnsCallback}
          allColumns={headers}
        />
        {hasPermission("show_application_commission") && (
          <>
            <table
              id="viewexpoList"
              className="table table-bordered bg-white table-responsive"
            >
              {/* Headers */}
              <thead className="thead-dark">
                <tr>
                  {headers.map(
                    (head) =>
                      head.checked && (
                        <th
                          id={head.dataKey}
                          className={head.align}
                          key={head.key}
                          onClick={() => sorting(head.dataKey)}
                        >
                          {head.title}
                        </th>
                      )
                  )}
                </tr>
              </thead>
              {/* End Headers */}
              <tbody>
                {state.allCommissions.map((value, index) => (
                  <tr key={index}>
                    {headers[0]["checked"] && (
                      <td className="text-center">{index + 1}</td>
                    )}
                    {headers[1]["checked"] && (
                      <td className="text-left">
                        <Link
                          to={`/clients/view-client-detail/${value.clientid}`}
                        >
                          {value.clientname}
                        </Link>
                      </td>
                    )}
                    {headers[2]["checked"] && (
                      <td className="text-center"> {value.installment_no}</td>
                    )}
                    {headers[3]["checked"] && (
                      <td className="text-center name-text">
                        <Link
                          to={`/applications/view-education-application-detail/${value.appid}`}
                        >
                          {value.coursename}
                        </Link>
                      </td>
                    )}
                    {headers[4]["checked"] && (
                      <td className="text-center name-text">{value.amount}</td>
                    )}
                    {headers[5]["checked"] && (
                      <td className="text-center">{value.commission}</td>
                    )}
                    {headers[6]["checked"] && (
                      <td className="text-center">{value.commissionincl}</td>
                    )}
                    {headers[7]["checked"] && (
                      <td className="text-center">{value.commissionexcl}</td> // typo in API: commissionexl → commissionexcl rendering
                    )}
                    {headers[8]["checked"] && (
                      <td className="text-center">
                        {value.duedate
                          ? moment(value.duedate).format("D MMM YYYY")
                          : ""}
                      </td>
                    )}
                    {state.sortType === "overdue" ? (
                      <>
                        {value.dueby != null && headers[9]["checked"] && (
                          <td className="text-center error">
                            {value.dueby < 0 && Math.abs(value.dueby) + " Days"}
                          </td>
                        )}
                        {headers[10]["checked"] && (
                          <td className="text-center">
                            {value.remaining_amount}
                          </td>
                        )}
                        {headers[11]["checked"] && (
                          <td
                            className={`text-center bold ${
                              value.status === "pending"
                                ? "text-red"
                                : "text-c-green"
                            }`}
                          >
                            {value.status}
                          </td>
                        )}
                        {headers[12]["checked"] && (
                          <td className="text-center">{value.discount}</td>
                        )}
                        {headers[13]["checked"] && (
                          <td className="text-center">
                            {value.discount_incl_gst}
                          </td>
                        )}
                        {headers[14]["checked"] && (
                          <td className="text-center">
                            {value.discount_excl_gst}
                          </td>
                        )}
                        {headers[15]["checked"] && (
                          <td className="text-center">{value.app_bonus}</td>
                        )}
                        {headers[16]["checked"] && (
                          <td className="text-center">
                            <div
                              className="acc-note pl-2 bold"
                              style={{ whiteSpace: "pre-wrap" }}
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(value.notes || ""),
                              }}
                            ></div>
                          </td>
                        )}
                        {headers[17]["checked"] && (
                          <td className="text-center">{value.pname}</td>
                        )}
                      </>
                    ) : (
                      <>
                        {headers[9]["checked"] && (
                          <td className="text-center">
                            {value.paiddate
                              ? moment(value.paiddate).format("D MMM YYYY")
                              : ""}
                          </td>
                        )}
                        {headers[10]["checked"] && (
                          <td className="text-center">
                            {value.remaining_amount}
                          </td>
                        )}
                        {headers[11]["checked"] && (
                          <td
                            className={`text-center bold ${
                              value.status === "pending"
                                ? "text-red"
                                : "text-c-green"
                            }`}
                          >
                            {value.status}
                          </td>
                        )}
                        {headers[12]["checked"] && (
                          <td className="text-center">{value.discount}</td>
                        )}
                        {headers[13]["checked"] && (
                          <td className="text-center">
                            {value.discount_incl_gst}
                          </td>
                        )}
                        {headers[14]["checked"] && (
                          <td className="text-center">
                            {value.discount_excl_gst}
                          </td>
                        )}
                        {headers[15]["checked"] && (
                          <td className="text-center">{value.app_bonus}</td>
                        )}
                        {headers[16]["checked"] && (
                          <td className="text-center">
                            <div
                              className="acc-note pl-2 bold"
                              style={{ whiteSpace: "pre-wrap" }}
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(value.notes || ""),
                              }}
                            ></div>
                          </td>
                        )}
                        {headers[17]["checked"] && (
                          <td className="text-center">{value.pname}</td>
                        )}
                        <td>
                          <button
                            className="btn btn-primary size-12 m-1"
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                openModal: true,
                              }));
                              setSelectedCommission(value);
                            }}
                          >
                            <FaIcons.FaDollarSign
                              size={12}
                              color={"#ffffffed"}
                            />
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {/* AppsCommission */}
            {state?.openModal && (
              <AppsCommission
                show={state.openModal}
                appid={selectedCommission?.appid}
                type={selectedCommission?.type}
                clientDetail={details}
                courseDetail={data}
                parentCallback={handleCommissiontModelCallback}
              />
            )}
            <Paginations
              currentPage={state.currentPage}
              total={state.totalItem}
              itemsPerPage={state.perPage}
              lastPage={state.lastPage}
              totalItems={state.totalItem}
              perItem={state.perItem}
              onPageChange={handlePaginationCallback}
            />

            {/* Exports */}
            {role === 2 && (
              <div className="d-flex mb-5">
                <ExportOptions
                  pdffilename={"Commissions.pdf"}
                  csvfilename={"Commissions.csv"}
                  xlsxfilename={"Commissions"}
                  header="Commissions List"
                  id="viewclientsdiv3"
                  columns={state.headers}
                  data={state.selectedCommissions}
                />
              </div>
            )}
            {/* End Exports */}
          </>
        )}
      </div>
    </>
  );
};

export default ViewCommissions;
